import { render, staticRenderFns } from "./PostAction.vue?vue&type=template&id=78d99ca4&"
import script from "./PostAction.vue?vue&type=script&lang=ts&"
export * from "./PostAction.vue?vue&type=script&lang=ts&"
import style0 from "./PostAction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports